import React, { useState, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';

const TermsAndConditions = ({ isVisible, onClose }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (isVisible) {
            // Use a timeout to allow the component to be added to the DOM before starting the animation
            const timer = setTimeout(() => {
                setShow(true);
            }, 10);
            return () => clearTimeout(timer);
        } else {
            setShow(false);
        }
    }, [isVisible]);

    const handleClose = () => {
        setShow(false);
        setTimeout(onClose, 300); // Match animation duration
    };

    const swipeHandlers = useSwipeable({
        onSwipedDown: () => handleClose(),
        preventScrollOnSwipe: true,
        trackMouse: true
    });

    if (!isVisible) {
        return null;
    }

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end z-50"
            onClick={handleClose}
        >
            <div
                {...swipeHandlers}
                className={`w-full h-4/5 bg-white rounded-t-2xl shadow-lg flex flex-col overflow-hidden transform transition-transform duration-300 ease-out ${show ? 'translate-y-0' : 'translate-y-full'}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="w-10 h-1.5 bg-gray-300 rounded-full self-center my-2.5 cursor-grab" />
                <div className="px-5 pb-5 overflow-y-auto flex-grow text-claraview-tertiary">
                    <h2 className="text-2xl font-bold mb-5 text-center text-[#2C2D24]">
                        Terms and Conditions
                    </h2>

                    <p className="text-base leading-relaxed mb-4">
                        <strong>Effective Date:</strong> 11/1/2025
                    </p>

                    <p className="text-base leading-relaxed mb-4">
                        Welcome to Claraview. These Terms & Conditions (“Terms”) govern your access
                        to and use of the Claraview smile simulation experience (“Service”)
                        provided by Claraview, Inc. (“Claraview,” “we,” “us,” or “our”). By
                        accessing or using the Service, you agree to be bound by these Terms.
                    </p>

                    <h3 className="text-lg font-semibold mt-4 mb-2">1. Use of the Service</h3>
                    <p className="text-base leading-relaxed mb-4">
                        Claraview provides a cosmetic smile simulation based on a photo you upload.
                        This tool is designed to give you a general idea of what your smile could
                        look like with cosmetic dental treatment. It is not a medical diagnosis,
                        treatment plan, or guarantee of results. You should consult with a licensed
                        dental professional for a personalized assessment.
                    </p>

                    <h3 className="text-lg font-semibold mt-4 mb-2">2. Eligibility</h3>
                    <p className="text-base leading-relaxed mb-4">
                        To use Claraview, you must be at least 18 years old or have the permission
                        of a parent or legal guardian. By using the Service, you represent and
                        warrant that you meet these requirements.
                    </p>

                    <h3 className="text-lg font-semibold mt-4 mb-2">3. Photo Uploads</h3>
                    <p className="text-base leading-relaxed mb-2">
                        By uploading your photo:
                    </p>
                    <ul className="list-disc pl-6 text-base leading-relaxed mb-4 space-y-2">
                        <li>
                            You affirm that the photo is your own or that you have permission to
                            upload it.
                        </li>
                        <li>
                            You grant Claraview a limited, non-exclusive, and revocable right to use
                            your image solely to generate your simulation.
                        </li>
                    </ul>

                    <h3 className="text-lg font-semibold mt-4 mb-2">4. Privacy</h3>
                    <p className="text-base leading-relaxed mb-4">
                        Claraview does not sell or share your personal data. For more details on how
                        we collect, store, and protect your information, please refer to our{" "}
                        <a
                            href="#"
                            className="text-blue-600 underline hover:text-blue-800 transition-colors"
                        >
                            Privacy Policy
                        </a>
                        .
                    </p>

                    <h3 className="text-lg font-semibold mt-4 mb-2">5. Limitations of Use</h3>
                    <p className="text-base leading-relaxed mb-2">You agree not to:</p>
                    <ul className="list-disc pl-6 text-base leading-relaxed mb-4 space-y-2">
                        <li>Use the simulation for any unlawful purpose.</li>
                        <li>Misrepresent your identity or upload misleading content.</li>
                        <li>Attempt to reverse-engineer, duplicate, or exploit the Service.</li>
                    </ul>

                    <h3 className="text-lg font-semibold mt-4 mb-2">6. Disclaimer</h3>
                    <p className="text-base leading-relaxed mb-4">
                        Claraview is for informational purposes only. Results are approximations and
                        should not be interpreted as clinical outcomes. We make no warranties
                        regarding the accuracy or suitability of the simulation.
                    </p>

                    <h3 className="text-lg font-semibold mt-4 mb-2">7. Limitation of Liability</h3>
                    <p className="text-base leading-relaxed mb-4">
                        To the fullest extent permitted by law, Claraview shall not be liable for
                        any indirect, incidental, or consequential damages arising from the use or
                        inability to use the Service.
                    </p>

                    <h3 className="text-lg font-semibold mt-4 mb-2">8. Modifications</h3>
                    <p className="text-base leading-relaxed mb-4">
                        We may update these Terms at any time. Continued use of the Service after
                        changes means you accept the updated Terms.
                    </p>

                    <h3 className="text-lg font-semibold mt-4 mb-2">9. Contact</h3>
                    <p className="text-base leading-relaxed mb-4">
                        For questions about these Terms or the Service, contact us at:
                    </p>
                    <p className="text-base font-medium mb-4">hello@claraview.ai</p>

                    <button
                        onClick={handleClose}
                        className="mt-5 p-3 text-lg bg-[#2C2D24] text-white rounded-lg font-medium w-full cursor-pointer"
                    >
                        Close
                    </button>
                </div>

            </div>
        </div>
    );
};

export default TermsAndConditions;

